<template>
    <div
        class="vimeo-video"
        ref="player"
    ></div>
</template>

<script>
import Player from '@vimeo/player';

let player = null;

export default {
    props: {
        id: null
    },

    watch: {
        id() {
            this.$nextTick(() => {
                this.init();
            });
        }
    },

    methods: {
        init() {
            try {
                if (this.id) {
                    player = new Player(this.$refs.player, {
                        id: parseInt(this.id),
                        controls: false
                    });

                    player.on('playing', () => {
                        this.$emit('play');
                    });

                    player.on('pause', () => {
                        this.$emit('pause');
                    });

                    player.on('timeupdate', (e) => {
                        this.$emit('timeupdate', {
                            percent: e.percent * 100,
                            seconds: e.seconds
                        });
                    });

                    player.on('volumechange', (e) => {
                        this.$emit('volumechange', e.volume);
                    });

                    player.on('ended', () => {
                        this.$emit('end');
                    });

                    this.$emit('ready');
                }
            } catch (e) {
                console.log(e);
            }
        },

        play() {
            if (player) {
                player.play();
            }
        },

        pause() {
            if (player) {
                player.pause();
            }
        },

        seek(value) {
            if (player) {
                player.setCurrentTime(value);
            }
        },

        setVolume(value) {
            if (player) {
                player.setVolume(value);
            }
        },

        fullscreen() {
            if (player) {
                player.requestFullscreen();
            }
        },

        getVolume() {
            if (player) {
                return player.getVolume();
            }
        },

        getDuration() {
            if (player) {
                return player.getDuration();
            }
        },

        getWidth() {
            if (player) {
                return player.getVideoWidth();
            }
        },

        getHeight() {
            if (player) {
                return player.getVideoHeight();
            }
        }
    },

    mounted() {
        this.init();
    }
}

</script>
